<div class="task">
  <div class="task__header">
    <textarea
      class="task__textarea task__name"
      tabindex="-1"
      rows="1"
      [ngModel]="task().name"
      (ngModelChange)="onUpdateTask({ name: $event })"
      >{{ task().name }}</textarea
    >
    <button
      class="task__header__cancel"
      (click)="dialogRef.close()"
      tabindex="1"
    >
      &times;
    </button>
  </div>
  <div class="task__inner">
    <div class="task__inner__fieldgroup task__labels">
      <label class="task__inner__fieldgroup__label" for="labels">Labels</label>
      <div class="task__labels__list">
        @for (label of task().labels; track label.id) {
          <button
            class="task__labels__list__button"
            [attr.data-color]="label.color"
            (click)="toggleLabelsPopover()"
          >
            {{ label.name }}
          </button>
        }
        @if (task().labels.length === 0) {
          <button
            class="task__labels__list__button"
            (click)="toggleLabelsPopover()"
          >
            Add Label
          </button>
        }
      </div>
      <app-popover
        class="task__labels__popover"
        [isOpen]="labelsPopEnabled"
        (popoverClosed)="disableLabelsPopover()"
      >
        <div class="task__labels__popover__header">
          <h4 class="task__labels__popover__title">Labels</h4>
        </div>

        @if (isAddingLabel) {
          <button (click)="setIsAddingLabel(false)">&leftarrow;</button>
          <form
            #form="ngForm"
            (submit)="onCreateLabel(form)"
            class="task__labels__popover__form"
          >
            <div class="task__labels__popover__form__group">
              <label for="name">Name</label>
              <input type="text" ngModel id="labelName" name="name" />
            </div>
            <div
              class="task__labels__popover__form__group task__labels__popover__form__colors"
            >
              <label for="color">Select Color</label>
              <div class="task__labels__popover__form__colors__grid">
                @for (color of availableColors; track color) {
                  <div class="task__labels__popover__form__colors__color">
                    <div
                      class="task__labels__popover__form__colors__color__inner"
                      [attr.data-color]="color"
                    >
                      <input
                        type="radio"
                        name="color"
                        id="color-{{ color }}"
                        ngModel
                        [value]="color"
                      />
                      <label for="color-{{ color }}">{{ color }}</label>
                    </div>
                  </div>
                }
              </div>
            </div>
            <input type="submit" value="Create" />
          </form>
        } @else if (editingLabel !== null) {
          <button (click)="setEditingLabel(null)">&leftarrow;</button>
          <form
            #form="ngForm"
            (submit)="onUpdateLabel(form)"
            class="task__labels__popover__form"
          >
            <div class="task__labels__popover__form__group">
              <label for="name">Name</label>
              <input
                type="text"
                [ngModel]="editingLabel.name"
                id="labelName"
                name="name"
              />
            </div>
            <div
              class="task__labels__popover__form__group task__labels__popover__form__colors"
            >
              <label for="color">Select Color</label>
              <div class="task__labels__popover__form__colors__grid">
                @for (color of availableColors; track color) {
                  <div class="task__labels__popover__form__colors__color">
                    <div
                      class="task__labels__popover__form__colors__color__inner"
                      [attr.data-color]="color"
                    >
                      <input
                        type="radio"
                        name="color"
                        id="color-{{ color }}"
                        [value]="color"
                        [ngModel]="editingLabel.color"
                      />
                      <label for="color-{{ color }}">{{ color }}</label>
                    </div>
                  </div>
                }
              </div>
            </div>
            <input type="submit" value="Update" />
            <button (click)="onDeleteLabel()" type="button">Delete</button>
          </form>
        } @else {
          <ul class="task__labels__popover__list">
            @for (label of labels(); track label.id; let i = $index) {
              <li class="task__labels__popover__list__item">
                <input
                  type="checkbox"
                  name="label.{{ label.id }}"
                  id="label.{{ label.id }}"
                  [checked]="hasLabel(label.id)"
                  (change)="handleLabelSelectChange(label, $event)"
                />
                <label
                  for="label.{{ label.id }}"
                  [attr.data-color]="label.color"
                  >{{ label.name }}</label
                >
                <button (click)="setEditingLabel(label)">&#x270E;</button>
              </li>
            }
            <button (click)="setIsAddingLabel(true)">Create New Label</button>
          </ul>
        }
      </app-popover>
    </div>

    <div class="task__inner__fieldgroup task__description">
      <label class="task__inner__fieldgroup__label" for="description"
        >Description</label
      >
      <textarea
        class="task__textarea task__description__input"
        name="description"
        tabindex="2"
        rows="8"
        [ngModel]="task().description"
        (ngModelChange)="onUpdateTask({ description: $event })"
        >{{ task().description }}</textarea
      >
      <!-- <textarea
        class="task__textarea task__description__input"
        name="description"
        tabindex="2"
        rows="3"
        [value]="task().description"
        (change)="onUpdateTask({ description: $event })"
        >{{ task().description }}</textarea
      > -->
    </div>
    <div class="task__inner__fieldgroup task__inner__row">
      <div class="task__inner__row">
        <div class="task__inner__row__col">
          <label for="start_date" class="task__inner__fieldgroup__label"
            >Start Date</label
          >
          <input
            type="datetime-local"
            name="start"
            id="start"
            date="yyyy-MM-ddThh:mm"
            [ngModel]="task().start_date | date: 'yyyy-MM-ddThh:mm'"
            (ngModelChange)="setDate('start_date', $event)"
          />
        </div>
        <div class="task__inner__row__col">
          <label for="start_date" class="task__inner__fieldgroup__label"
            >Due Date</label
          >
          <input
            type="datetime-local"
            name="due"
            id="due"
            [ngModel]="task().due_date | date: 'yyyy-MM-ddThh:mm'"
            (ngModelChange)="setDate('due_date', $event)"
          />
        </div>
      </div>
    </div>
    <div class="task__inner__fieldgroup">
      <strong class="task__inner__fieldgroup__label">Connected Contact</strong>
      <a [href]="task().contact?.edit_url" target="_blank">
        {{ task().contact?.display ?? 'None' }}
      </a>
    </div>
    <div class="task__inner__fieldgroup task__assign">
      <label for="assignments" class="task__inner__fieldgroup__label"
        >Task Assignments</label
      >

      <div class="task__assign__previews">
        @for (assignment of task().user_assignments; track assignment.id) {
          <app-user-preview [userId]="assignment.user" />
        }
      </div>
      <button (click)="setIsAssigningUser(true)">Assign Users</button>

      <app-popover
        [isOpen]="isAssigningUser"
        (popoverClosed)="setIsAssigningUser(false)"
        class="task__assign__popover"
      >
        <ul class="task__assign__popover__list">
          @for (user of users(); track user.id) {
            <li class="task__assign__popover__list__item">
              <input
                type="checkbox"
                name="task-assignment"
                id="task-assignment-{{ user.id }}"
                [value]="user.id"
                [defaultChecked]="taskHasUser(user)"
                (change)="onAssignmentChange(user, $event)"
              />
              <label for="task-assignment-{{ user.id }}">
                <app-user-preview [userId]="user.id" />
                {{ user.display_name }}</label
              >
            </li>
          }
        </ul>
      </app-popover>
    </div>
  </div>
  <div class="task__actions">
    <p>&nbsp;</p>

    <button
      class="task__actions__button"
      (click)="dialogRef.close({ action: 'delete', task: task() })"
      id="delete-action"
      tabindex="4"
    >
      Delete
    </button>
  </div>
</div>
